import React, { Component } from 'react'
import GetInTouch from '../GetInTouch/BusinessProfileContainer'
import '../NjtHomeOne/NjtHomeOne.css'

class NjtSignUpForm extends Component {
    state = {
      showTermAndCondition: false,
      //agreementVersionAccepted: 0
      retailerData:{},
      agreementVersionAccepted:0
    }
    componentDidMount() {
      window.scrollTo(0, 0);
    }

    componentWillUnmount() {

      console.log("unmount component")
    }

    scrollToThankyou = () => {

        this.Thankyou.scrollIntoView({
          behavior: "smooth",
          // block: "end",
          inline: "nearest",
        });
      };

      

    render() {
        return (
            <main className="njt-sign-wrap">
                <div className="njt-sign-body">
                    <div ref={(el) => {this.Thankyou = el;}} className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <h1 role="alert" className="njt-sign-heading">Become a Partner</h1>
                            </div>
                        </div>
                    </div>

                    <GetInTouch
                      scrollToThankyou={this.scrollToThankyou}
                      // is_rapid_registration_on={this.props.is_rapid_registration_on}
                    />
                </div>
            </main>
        )
    }
}

export default NjtSignUpForm
